(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name documentManager.factory:DocumentManagerAdaptorFactory
     *
     * @description
     *
     */
    angular
        .module('documentManager')
        .factory('DocumentManagerAdaptorFactory', DocumentManagerAdaptorFactory);
    
    function DocumentManagerAdaptorFactory(DocumentManagerRequestFactory) {
        
        function adaptFormSubmit(formData, jsonData) {
            if(!!!formData){
                formData = new FormData();
            }
            if(formData.get('documentMeta')){
                formData.delete('documentMeta');
            }
            formData.append('documentMeta', JSON.stringify(AdeptDocumentMetaJson(jsonData)));
            return formData
        }
        
        function AdeptDocumentMetaJson(jsonData) {
            var request = DocumentManagerRequestFactory.getDocumentUploadRequest();
            request.title = jsonData.title;
            request.summary = jsonData.summary;
            request.categoryCode = jsonData.category.categoryCode;
            request.status = jsonData.status?'INA':'ACT';
            request.crewTypeCode = [];
            _.each(jsonData.crewType, function (ct) {
                request.crewTypeCode.push(ct.crewTypeCode)
            });
            request.crewProfileId = [];
            _.each(jsonData.crewProfileIds, function (cp) {
                request.crewProfileId.push(cp.crewProfileId)
            });
            request.downloadId = jsonData.downloadId;
            request.version = jsonData.version;
            request.filePath = jsonData.filePath;
            request.validUntilDate = jsonData.validUntilDate;
            request.concatanateDateTimeToFilePath = jsonData.concatanateDateTimeToFilePath;
            return request;
        }
        
        function formatDocumentList(documents) {
            _.each(documents, function (doc) {
                doc.actionFlag = false;
            });
            return documents;
        }

        function adeptDeleteRQ(document) {
            return {
                downloadId : document.downloadId,
                version : document.version
            }
        }

        function formatCrew(crewList) {
            var returnList = [];
            _.each(crewList, function (crew) {
                returnList.push({
                    crewProfileId:crew.crewProfileId,
                    crewId:crew.crewId,
                    crewName: "(" + crew.crewType +") " + crew.firstName + " " + crew.lastName
                });
            });
            return returnList;
        }
        
        return {
            adaptFormSubmit: adaptFormSubmit,
            adeptDeleteRequest: adeptDeleteRQ,
            formatDocumentList: formatDocumentList,
            formatCrew: formatCrew
        }
    }
})();